import { Stack, SxProps, Typography } from '@mui/material';
import { SuppliersContext } from 'Context/SuppliersContext';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { useContext } from 'react';
import { ResetFilterButtons } from '../../ResetFilterButtons';
import { SUPPLIER_RESULT_FILTER } from 'Enum/suppliers';

export const General = () => {
  const { filters, setFilters, dispatchSuppliers, userLocation } =
    useContext(SuppliersContext);

  const dictionary = useDictionary(Dictionary, DICTIONARY.Suppliers).resultPage;

  const sortStyle: SxProps = {
    p: '6px 0 6px 16px',

    ':hover': {
      cursor: 'pointer',
      bgcolor: 'primary.shade_50_2',
    },
  };

  const sortHandler = (isAscending: boolean) => {
    const updatedFilters = {
      ...filters,
      orderByAscendingAlphabet: isAscending,
      orderByDescendingAlphabet: !isAscending,
    };
    setFilters(updatedFilters);
    dispatchSuppliers({
      type: SUPPLIER_RESULT_FILTER.Therapy,
      payload: { value: updatedFilters },
    });
  };

  const locationHandler = () => {
    const updatedFilters = {
      ...filters,
      location: filters.location ? null : userLocation,
    };
    setFilters(updatedFilters);
    dispatchSuppliers({
      type: SUPPLIER_RESULT_FILTER.Therapy,
      payload: { value: updatedFilters },
    });
  };

  const resetHandler = () => {
    const updatedFilters = {
      ...filters,
      orderByAscendingAlphabet: false,
      orderByDescendingAlphabet: false,
      location: null,
    };
    setFilters(updatedFilters);
    dispatchSuppliers({
      type: SUPPLIER_RESULT_FILTER.Therapy,
      payload: { value: updatedFilters },
    });
  };

  return (
    <Stack
      sx={{
        pb: '60px',
      }}
    >
      <Typography
        variant='body6'
        sx={{
          ...sortStyle,
          bgcolor: filters.location ? 'primary.shade_100' : undefined,
          fontWeight: filters.location ? '600 !important' : undefined,
        }}
        onClick={() => locationHandler()}
      >
        {dictionary.closestLocation}
      </Typography>
      <Typography
        variant='body6'
        sx={{
          ...sortStyle,
          bgcolor: filters.orderByAscendingAlphabet
            ? 'primary.shade_100'
            : undefined,
          fontWeight: filters.orderByAscendingAlphabet
            ? '600 !important'
            : undefined,
        }}
        onClick={() => sortHandler(true)}
      >
        {dictionary.orderByAscendingAlphabet}
      </Typography>
      <Typography
        variant='body6'
        sx={{
          ...sortStyle,
          bgcolor: filters.orderByDescendingAlphabet
            ? 'primary.shade_100'
            : undefined,
          fontWeight: filters.orderByDescendingAlphabet
            ? '600 !important'
            : undefined,
        }}
        onClick={() => sortHandler(false)}
      >
        {dictionary.orderByDescendingAlphabet}
      </Typography>
      <ResetFilterButtons
        resetCallback={() => resetHandler()}
        sx={{
          justifyContent: 'flex-start',
        }}
      />
    </Stack>
  );
};
